import axios from 'axios'
import store from '~/store'
import router from '~/router'
import swal from 'sweetalert2'
import i18n from '~/plugins/i18n'

let reqs = 0

// Request interceptor
axios.interceptors.request.use(request => {
  const token = store.getters['auth/token']
  if (token) {
    request.headers.common['Authorization'] = `Bearer ${token}`
  }

  const locale = store.getters['lang/locale']
  if (locale) {
    request.headers.common['Accept-Language'] = locale
  }

  document.getElementById('loader-main').style.display = 'block'
  document.body.style.pointerEvents = 'none'
  // request.headers['X-Socket-Id'] = Echo.socketId()
  reqs++
  return request
})

// Response interceptor
  axios.interceptors.response.use(response => {
  reqs--
  if (reqs === 0) {
    document.getElementById('loader-main').style.display = 'none'
    document.body.style.pointerEvents = 'all'
  }
  return response
  }, error => {
  const { status } = error.response
  reqs--
  if (reqs === 0) {
    document.getElementById('loader-main').style.display = 'none'
    document.body.style.pointerEvents = 'all'
  }
  if (status >= 500) {
    swal({
      type: 'error',
      title: i18n.t('error_alert_title'),
      text: i18n.t('error_alert_text'),
      reverseButtons: true,
      confirmButtonText: i18n.t('ok'),
      cancelButtonText: i18n.t('cancel')
    })
  }

  if (status === 401 && store.getters['auth/check']) {
    swal({
      type: 'warning',
      title: i18n.t('token_expired_alert_title'),
      text: i18n.t('token_expired_alert_text'),
      reverseButtons: true,
      confirmButtonText: i18n.t('ok'),
      cancelButtonText: i18n.t('cancel')
    }).then(() => {
      store.commit('auth/LOGOUT')

      router.push({ name: 'login' })
    })
  }

  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./resources/js/plugins/axios.js